import React from 'react';

export function PlayIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6613 6.39977L3.73464 11.1798C3.26797 11.4598 2.66797 11.1264 2.66797 10.5798V5.24643C2.66797 2.91976 5.1813 1.46643 7.2013 2.62643L10.2613 4.38643L11.6546 5.18643C12.1146 5.45976 12.1213 6.12643 11.6613 6.39977Z"
        fill="currentColor"
      />
      <path
        d="M12.6094 7.54883C12.662 7.51727 12.7223 7.51651 12.7734 7.53906C12.8224 7.56073 12.8507 7.59766 12.8584 7.64551L12.8594 7.64648C12.9962 8.49474 12.646 9.39311 11.8105 9.87305L11.8096 9.87402L9.10938 11.4336L6.41797 12.9863C5.62789 13.4386 4.74276 13.3449 4.10059 12.8916L4.09668 12.8887L4.0752 12.8691C4.05606 12.847 4.04403 12.816 4.04688 12.7734C4.05096 12.7139 4.08329 12.6607 4.13379 12.6309L4.13672 12.6289L12.6094 7.54883Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
}
